import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { ProjectStatusesEnum } from '@thinknet-gmbh/platform-common';

export const PROJECT_TYPE_COLORS = {
  [ProjectStatusesEnum.ACTIVE]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [ProjectStatusesEnum.ARCHIVED]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
  [ProjectStatusesEnum.DELETED]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
  [ProjectStatusesEnum.FINISHED]: {
    background: PLATFORM_THEME_COLORS.tone.lightBlue,
    fontColor: PLATFORM_THEME_COLORS.primary.blue,
  },
};

export const PROJECT_MODALS = {
  deleteProject: 'deleteProject',
  deleteTask: 'deleteTask',
  archiveProject: 'archiveProject',
  unarchiveProject: 'unarchiveProject',
  finishProject: 'finishProject',
  projectTableFilter: 'projectTableFilter',
  useTaskTemplate: 'useTaskTemplate',
  activateProject: 'activateProject',
  kwpProjects: 'kwpProjects',
};
